import React from 'react';
import loadable from '@loadable/component';
import sanitizeRedirectLocation from 'helpers/sanitizeRedirectLocation';

const Login = loadable(() => import('features/Login/LoginContainer'));

export const LoginRoute = store => ({
  path: '/login',

  onEnter: (nextState, replaceState, cb) => {
    // there are instances where we want the user to remain in the login screen
    if (store.getState().user.loggedIn && !nextState.location.query.noRedirect) {
      if (nextState.location.query && nextState.location.query.returnTo) {
        replaceState(sanitizeRedirectLocation(nextState.location.query.returnTo));
      } else if (nextState.params && nextState.params.splat) {
        replaceState(sanitizeRedirectLocation(nextState.params.splat));
      } else {
        replaceState('/');
      }
    }
    cb();
  },
  indexRoute: {
    component: props => <Login {...props} />,
  },
  childRoutes: [
    { path: '*', component: props => <Login {...props} /> },
    { path: '**/*', component: props => <Login {...props} /> },
  ],
});
